module.exports = __webpack_public_path__ + "img/blue-hacker.84bd5ca4.svg";